import { getFormattedDateWithTime } from "components/common/Utility"

export const ItemExclusionConfigColumnDef = [
        {
            headerName: "",
            field: "selected",
            cellEditor: "agCheckboxCellEditor",
            editable: (params) => {
                return params.data.status === "active"
            },
            minWidth: 50,
            maxWidth: 80,
        },
        {
            headerName: "PIN",
            field: "item",
            filter: false,
            minWidth: 60,
            maxWidth: 80,
        },
        {
            headerName: "Description",
            field: "itemDescription",
            filter: false,
            tooltipValueGetter: (params) => params.value,
        },
        {
            headerName: "Updated By",
            field: "lastUpdatedBy",
            filter: false,
        },
        {
            headerName: "Updated At",
            valueGetter: (params) => {
                return getFormattedDateWithTime(params.data.lastUpdatedAt)
            },
            filter: false,
            minWidth: 80,
            maxWidth: 120, 
        }
    ]

